/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {getVbusFirmware, PLATFORM_IDS} from '@ion/core/src/utils/DeviceUtils';
import {GridResult} from '@ion/dls/src/grid/PaginationControls';
import JobIdLinks from './JobIdLinks';

export interface PendingJobIdLinksType {
  data: GridResult;
  isVbuFwEnabled?: boolean;
}

export const PendingJobIdLinks = ({data, isVbuFwEnabled = true}: PendingJobIdLinksType) => {
  const filterPlatformIds = data?.fileHistoryPending?.filter((item) =>
    isVbuFwEnabled ? getVbusFirmware(data, item.platformId)
      : item.platformId === PLATFORM_IDS.jpodFirmware ||
      item.platformId === PLATFORM_IDS.jpod2Firmware
  );
  return <JobIdLinks data={filterPlatformIds?.[0]} pendingJobIds={filterPlatformIds} isPendingJpodFW/>;
};

export default PendingJobIdLinks;
